import { c as create_ssr_component, e as escape, b as add_attribute, v as validate_component } from "../../../../chunks/ssr.js";
import { E as EditorToolbar_1 } from "../../../../chunks/PlainText.js";
import "../../../../chunks/util.js";
import { S as SecondaryButton } from "../../../../chunks/SecondaryButton.js";
import { W as WebsiteNav } from "../../../../chunks/WebsiteNav.js";
import "../../../../chunks/client.js";
import { F as Footer } from "../../../../chunks/Footer.js";
import { R as RecipientsSelector, P as Post } from "../../../../chunks/Post.js";
import { N as NotEditable } from "../../../../chunks/NotEditable.js";
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let currentUser;
  let { data } = $$props;
  let editable, title, content, created_at, teaser, is_public, recipients;
  let showMenu;
  function initOrReset() {
    title = data.title;
    content = data.content;
    created_at = data.created_at;
    data.teaser_image;
    teaser = data.teaser;
    is_public = data.is_public;
    recipients = data.recipients;
    editable = false;
  }
  if ($$props.data === void 0 && $$bindings.data && data !== void 0)
    $$bindings.data(data);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    {
      {
        data = data;
        initOrReset();
      }
    }
    currentUser = data.currentUser;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-1coy6qs_START -->${$$result.title = `<title>${escape(title)}</title>`, ""}<meta name="description"${add_attribute("content", teaser, 0)}><meta name="og:title" property="og:title"${add_attribute("content", title, 0)}><meta name="og:description" property="og:description"${add_attribute("content", teaser, 0)}><meta name="og:image" property="og:image"${add_attribute("content", data.teaser_image || data.bio.avatar, 0)}><meta name="twitter:card" content="summary"><meta name="twitter:title"${add_attribute("content", title, 0)}><meta name="twitter:description"${add_attribute("content", teaser, 0)}><meta name="twitter:image"${add_attribute("content", data.teaser_image || data.bio.avatar, 0)}><link href="/feed.xml" rel="alternate" type="application/rss+xml"${add_attribute("title", data.bio.name, 0)}><link rel="icon" type="image/png" sizes="300x300"${add_attribute("href", data.bio.avatar, 0)}><link rel="apple-touch-icon" sizes="300x300"${add_attribute("href", data.bio.avatar, 0)}><meta name="robots" content="index, follow"><!-- HEAD_svelte-1coy6qs_END -->`, ""} ${editable ? `${validate_component(EditorToolbar_1, "EditorToolbar").$$render($$result, { canConfirm: !!title }, {}, {})}` : ``} ${validate_component(WebsiteNav, "WebsiteNav").$$render(
      $$result,
      {
        bio: data.bio,
        backButton: true,
        editable,
        showMenu
      },
      {
        editable: ($$value) => {
          editable = $$value;
          $$settled = false;
        },
        showMenu: ($$value) => {
          showMenu = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${currentUser ? `<div class="space-y-4 flex flex-col">${validate_component(SecondaryButton, "SecondaryButton").$$render($$result, { size: "sm" }, {}, {
            default: () => {
              return `Edit post`;
            }
          })} ${validate_component(SecondaryButton, "SecondaryButton").$$render($$result, { size: "sm" }, {}, {
            default: () => {
              return `Delete post`;
            }
          })}</div>` : ``}`;
        }
      }
    )} <div class="pt-8 sm:pt-16"></div> ${currentUser ? `${validate_component(RecipientsSelector, "RecipientsSelector").$$render(
      $$result,
      {
        slug: data.slug,
        editable,
        is_public,
        recipients
      },
      {
        is_public: ($$value) => {
          is_public = $$value;
          $$settled = false;
        },
        recipients: ($$value) => {
          recipients = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : ``} ${validate_component(Post, "Post").$$render(
      $$result,
      { editable, title, content, created_at },
      {
        title: ($$value) => {
          title = $$value;
          $$settled = false;
        },
        content: ($$value) => {
          content = $$value;
          $$settled = false;
        },
        created_at: ($$value) => {
          created_at = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(NotEditable, "NotEditable").$$render($$result, { editable }, {}, {
      default: () => {
        return `<div class="text-center max-w-screen-sm mx-auto px-6 py-12 sm:py-16"><div class="pb-4 text-center"><a href="/"><img${add_attribute("src", data.bio.avatar, 0)}${add_attribute("alt", data.bio.name, 0)} class="inline-block w-16 h-16 md:w-16 md:h-16 rounded-full"></a></div> <div class="text-center pb-4 sm:pb-8"><a href="/" class="text-2xl font-bold underline">${escape(data.bio.name)}</a></div>  <p class="sm:text-lg prose"><!-- HTML_TAG_START -->${data.bio.bio}<!-- HTML_TAG_END --></p></div>`;
      }
    })} ${validate_component(Footer, "Footer").$$render($$result, { editable, counter: `/blog/${data.slug}` }, {}, {})}`;
  } while (!$$settled);
  return $$rendered;
});
export {
  Page as default
};
